import { combineReducers } from "redux";

import ajaxCounter from "./ajaxCounterReducer";

import settings from "./settingReducer";
import layout from "./layoutReducer";
import exception from "./exceptionReducer";
import validatieStatussen from "./validatieStatusReducer";

import referentie from "./referentieReducer";
import adressen from "./adresGatewayReducer";

const rootReducer = combineReducers({
	ajaxCounter,
	settings,
	layout,
	validatieStatussen,
	referentie,
	adressen,
	exception
});

export default rootReducer;
